import { render, staticRenderFns } from "./resignation-filters.component.vue?vue&type=template&id=0403729d&scoped=true&"
import script from "./resignation-filters.component.vue?vue&type=script&lang=ts&"
export * from "./resignation-filters.component.vue?vue&type=script&lang=ts&"
import style0 from "./resignation-filters.component.vue?vue&type=style&index=0&id=0403729d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0403729d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCol,VRow})
